import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const t = "audio";
class r extends s {
  /**
   * Uploads an audio file for call deflection.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/audio`
   *
   * @param {File} audio_file - The audio file to be uploaded.
   * @returns {Promise<UploadAudioResponse>} A promise resolving to the upload response,
   *          which includes the status and transcoded audio information.
   */
  uploadAudio = async (e) => {
    const a = new FormData();
    return a.append("audio_file", e), a.append("transcode_formats", "mp3"), this.post(t, a).then(({ data: o }) => o);
  };
}
export {
  t as AUDIO_UPLOAD_URI,
  r as MessagingCallDeflection
};
